// extracted by mini-css-extract-plugin
export default {"topWrapper":"WizardTitleBlock_topWrapper__oO27y"};